module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/28/assets/images/29791684d5e4307b99639946cfe4f744.png";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/emerald.png
// module id = 5DKS
// module chunks = 0